import React from "react";

import Col from "antd/es/col";
import Row from "antd/es/row";
import cn from "classnames";
import { useIntl } from "react-intl";

import Activity from "@mapmycustomers/shared/types/entity/Activity";
import { Button } from "@mapmycustomers/ui";

import layout from "@app/styles/layout";

import FrequencyEntity from "../type/FrequencyEntity";
import hasFrequency from "../util/hasFrequency";

import styles from "./FrequencyPreview.module.scss";
import messages from "./messages";

interface Props {
  applyDisabled: boolean;
  entity?: FrequencyEntity;
  hasChanges: boolean;
  isGroup?: boolean;
  lastCompletedActivity?: Activity;
  loading?: boolean;
  onApply: () => void;
  onCancel?: () => void;
  onDelete: () => void;
  readonly?: boolean;
  saveButtonText?: string;
  showSaveButtonsOnlyAfterChanges?: boolean;
}

const Footer = ({
  applyDisabled,
  entity,
  hasChanges,
  isGroup,
  loading,
  onApply,
  onCancel,
  onDelete,
  readonly,
  saveButtonText,
  showSaveButtonsOnlyAfterChanges,
}: Props) => {
  const intl = useIntl();

  return (
    <>
      {!readonly && (
        <div className={styles.line}>
          {!hasChanges && !isGroup && entity && hasFrequency(entity) && (
            <div className={styles.removeButtonWrapper}>
              <Button danger disabled={loading} onClick={onDelete} size="small" type="link">
                {intl.formatMessage(messages.remove)}
              </Button>
            </div>
          )}
        </div>
      )}
      {!readonly && (
        <div className={cn(styles.line, styles.bottom)}>
          {(!showSaveButtonsOnlyAfterChanges || hasChanges) && (
            <Row className={styles.changesWrapper} gutter={layout.spacerS} justify="end">
              {isGroup && (
                <Col>
                  <Button danger disabled={loading} onClick={onDelete} size="small" type="text">
                    {intl.formatMessage(messages.delete)}
                  </Button>
                </Col>
              )}
              <Col>
                <Button disabled={loading} onClick={onCancel} size="small" type="default">
                  {intl.formatMessage(messages.cancel)}
                </Button>
              </Col>
              <Col>
                <Button
                  disabled={applyDisabled}
                  loading={loading}
                  onClick={onApply}
                  size="small"
                  type="primary"
                >
                  {saveButtonText ?? intl.formatMessage(messages.setFrequency)}
                </Button>
              </Col>
            </Row>
          )}
        </div>
      )}
    </>
  );
};

export default Footer;
